import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnnouncementData } from './announcement-modal.interface';

@Component({
  selector: 'so-announcement-modal',
  templateUrl: './so-announcement-modal.component.html',
  styleUrl: './so-announcement-modal.component.scss'
})
export class SoAnnouncementModalComponent {

  constructor(
    public dialogRef: MatDialogRef<SoAnnouncementModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AnnouncementData,
  ){}

  public confirm(): void {
    this.dialogRef.close(true);
  }
}
